module.exports = __webpack_public_path__ + "24bd6fd77bd04281aecfa43b70b0dc89.svg";